// src/components/ProtectedRoute.js
import React,{useEffect} from "react";
import { Navigate ,useLocation,useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import { homePagePath } from "../../constant";

const ProtectedRoute = ({ children, requiredRole }) => {
const { isLoggedIn, role, providerTypes } = useSelector(
  (state) => state.auth
);
console.log("requiredRole in protected", requiredRole, providerTypes, role);

if (!isLoggedIn) {
  return <Navigate to={"/401"} />;
}

// Convert both to lowercase for case-insensitive comparison
const requiredRoleLower = requiredRole?.toLowerCase();
const userRoleLower = role?.toLowerCase();

if (requiredRoleLower === "admin" && userRoleLower === "provider") {
  return children; // Access granted to admins
}

  return <Navigate to={homePagePath} />;
};

export default ProtectedRoute;
